


import { Box, Grid, Paper } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import {
  MRT_GlobalFilterTextField,
  MRT_TableContainer,
  useMaterialReactTable,
} from 'material-react-table';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { useEffect, useState } from 'react';
import NoRecord from 'screens/sharedScreens/noRecord/NoRecord';
import * as XLSX from 'xlsx';
import './MaterialTable.scss';



function ReactTable(props) {
  const { tableColumn, enableRowNumbers, enableRowSelection, setSelectedRows, exportExcel, pagesize } = props
  const [columns, setColumns] = useState(tableColumn);
  const [data, setData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const paginatorModel = new PaginatorModel();
  const [rowsPerPage, setRowsPerPage] = useState(pagesize===undefined ? paginatorModel.pageSize : pagesize);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [blankData, setBlankData] = useState(false);
  const [rowSelection, setRowSelection] = useState({});


  const handleChangePage = (event, newPage) => {
    // props.tableData= undefined;
    setPage(newPage);
    props.setPagination({
      pageSize: rowsPerPage !== undefined ? rowsPerPage : paginatorModel.pageSize,
      pageNumber: newPage,
      filter: globalFilter != undefined ? globalFilter : "",
      orderBy: sorting.length > 0 ? sorting[0]?.id : "",
      desc: sorting.length > 0 ? sorting[0]?.desc : ""
    })
  };

  const handleChangeRowsPerPage = (event) => {
    //  props.tableData= undefined;
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    props.setPagination({
      pageSize: (parseInt(event.target.value)),
      pageNumber: 0,
      filter: globalFilter != undefined ? globalFilter : "",
      orderBy: sorting.length > 0 ? sorting[0]?.id : "",
      desc: sorting.length > 0 ? sorting[0]?.desc : ""
    })
  };


  useEffect(() => {
    //  props.tableData= undefined;
    props.setPagination({
      pageSize: rowsPerPage !== undefined ? rowsPerPage : paginatorModel.pageSize,
      pageNumber: 0,
      filter: globalFilter != undefined ? globalFilter : "",
      orderBy: sorting.length > 0 ? sorting[0]?.id : "",
      desc: sorting.length > 0 ? sorting[0]?.desc : ""
    })
  }, [sorting]);

  useEffect(() => {
    //  props.tableData= undefined;
    try {
      setBlankData((props?.tableData?.data?.tbody?.length !== 0 && props?.tableData?.data?.tbody != undefined) ? false : true);
      if (props?.tableData?.data?.thead) {
        setData(props?.tableData?.data?.tbody);
      }
      if (props?.tableData?.data?.tfoot) {
        setRowCount(props?.tableData?.data?.tfoot?.totalListSize);
      }
    } catch (e) {
    }
  }, [props?.tableData?.data]);

  //to get selected rows
  useEffect(() => {
    if (setSelectedRows != undefined) {
      const rows = table.getSelectedRowModel().rows;
      const selectedRow = rows.map((data) => { return data.original })
      setSelectedRows([]);
      if (setSelectedRows !== undefined)
        setSelectedRows(selectedRow);
    }
  }, [rowSelection]);



  useEffect(() => {
    filterChange();
  }, [globalFilter]);


  const downloadExcelFile = () => {
    if (exportExcel?.data?.length > 0) {
      const fileName = exportExcel.fileName;
      const workSheet = XLSX.utils.json_to_sheet(exportExcel?.data);
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "sheet")
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" })
      XLSX.writeFile(workBook, "" + fileName)
    }
  }
  const filterChange = () => {
    props.setPagination((prev) => ({
      ...prev,
      filter: globalFilter ?? "", // Ensure it sends an empty string when cleared
      pageNumber: 0, // Reset to the first page when filtering
    }));
  };
  
  
  const table = useMaterialReactTable({
    columns,
    data,

    enableRowNumbers: enableRowNumbers !== undefined ? enableRowNumbers : true,

    //to display checkbox
    enableRowSelection: enableRowSelection != undefined ? enableRowSelection : false,
    onRowSelectionChange: setRowSelection,

    //Apply loading if data is not loaded
    state: {
      isLoading: (props?.tableData?.data?.tbody && props?.tableData?.data !== '') ? false : true,
      sorting,
      rowSelection,
      // globalFilter,
    },

    enableColumnActions: false,

    //to apply ordering
    enableColumnOrdering: true,

    //To make our header sticky
    enableStickyHeader: true,

    // enableClickToCopy: true,


  
    //layoutMode: "semantic",
    //to disable drag option of column header
    enableColumnDragging: false,



    //to display Action buttons
    enableRowActions: props.actions ? true : false,
    positionActionsColumn: 'last',

    //To apply basic initial values
    initialState: {
      showGlobalFilter: true,
      columnPinning: { right: ['mrt-row-actions'] },
      density: 'compact',
    },

    //Filter options
    manualFiltering: true,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: 'includesString',

    manualPagination: true,

    onSortingChange: setSorting,


    muiCircularProgressProps: {
      color: 'primary',
      thickness: 3,
      size: 45,
    },
    muiSkeletonProps: {
      animation: 'wave',
      height: 28,
    },

    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .1)',
        boxShadow: 'none'
      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, 0)',
      },
    },

  });

  return (

    <>
  

      <Paper sx={{
                backgroundColor: 'inherit',
                justifyContent: 'space-between',
                padding: '20px 14px',
                flexDirection: 'row',
                gap: '16px',
                boxShadow: 'none',
                backgroundColor: '#ffffff',
                '@media max-width: 768px': {
                  flexDirection: 'column',
                }
              }}>
        {/* Our Custom External Top Toolbar */}
        <Grid className='search-box-section'container spacing={2}>
          <Grid className='search-box-sec' item xs={12} sm={12} md={12} lg={12} display={"flex"}>
            <Box display={"flex"} paddingBottom={"10px"}>
              <MRT_GlobalFilterTextField table={table} autoComplete="off"/>
            </Box>
          </Grid>
        </Grid>
        {!blankData && props.tableData!=undefined  ? (
        <Box>
         
        <MRT_TableContainer  table={table} sx={{
                  width: "100%",
                  height: props.height ? props.height : "46vh",
                  overflowY: "auto",
                  "& th": {
                    backgroundColor: "#dbdbf7",
                    fontSize: "1.1rem"
                  },
                  "& td": {
                    fontSize: "1rem",
                    // padding: "7px"
                  }
                }}/>
              
        <TablePagination
          component="div"
          rowsPerPageOptions={new PaginatorModel().pageSizeOptions}
          count={rowCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton={true}
          showLastButton={true}


        />
        </Box>
        ):(
          <>
        <NoRecord></NoRecord>
 
          </>
        )}
      </Paper>
    </>
  );
}

export default ReactTable